import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';

import BasicTemplate from './BasicTemplate.js'
import { WAButton, PhoneButton } from '../components/Button.js';
import GreetingsModal from './GreetingsModal.js';


function RejectedVineyards(props) {
    return (
        <BasicTemplate>
            <h3><p className='red-text'>El CUIT ingresado registra más de 20 hectáreas.</p></h3>
            <h3><p className='red-text'>Para obtener tu crédito de Cosecha y Acarreo, con tasa bonificada por el FTyC, deberás dirigirte al Banco De la Nación Argentina.</p></h3>
            <GreetingsModal/>
        </BasicTemplate>
        );
};
export default RejectedVineyards;


/** WEBPACK FOOTER **
 ** ./src/components/RejectedVineyards.js
 **/